import { Link } from 'react-router-dom'
import { Input, Button, Row, Col, Typography, Space, Divider } from 'antd'
import { MailOutlined, PhoneOutlined, EnvironmentOutlined, GithubOutlined, TwitterOutlined, LinkedinOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerSections = [
    {
      title: 'Produkt',
      links: [
        { name: 'Funktionen', href: '/features' },
        { name: 'Preise', href: '/pricing' },
        { name: 'Demo buchen', href: '/contact' },
      ]
    },
    {
      title: 'Lösungen nach Branche',
      links: [
        { name: 'Software Entwicklung', href: '/zeiterfassung-software-entwicklung' },
        { name: 'Consulting & Beratung', href: '/zeiterfassung-consulting' },
        { name: 'Marketing Agenturen', href: '/zeiterfassung-marketing' },
        { name: 'Freelancer & Selbständige', href: '/zeiterfassung-freelancer' },
      ]
    },
    {
      title: 'Regionale Lösungen',
      links: [
        { name: 'Zeiterfassung Berlin', href: '/zeiterfassung-berlin' },
        { name: 'Zeiterfassung München', href: '/zeiterfassung-muenchen' },
        { name: 'Zeiterfassung Hamburg', href: '/zeiterfassung-hamburg' },
        { name: 'Zeiterfassung Köln', href: '/zeiterfassung-koeln' },
      ]
    },
    {
      title: 'Unternehmen',
      links: [
        { name: 'Über uns', href: '/about' },
        { name: 'Kontakt', href: '/contact' },
        { name: 'Blog', href: '#blog' },
        { name: 'Karriere', href: '#karriere' },
      ]
    },
    {
      title: 'Support & Rechtliches',
      links: [
        { name: 'Hilfe Center', href: '/help' },
        { name: 'Systemstatus', href: '/status' },
        { name: 'Impressum', href: '/impressum' },
        { name: 'Datenschutz', href: '/datenschutz' },
      ]
    }
  ]

  const socialLinks = [
    { name: 'Twitter', icon: TwitterOutlined, href: '#twitter' },
    { name: 'LinkedIn', icon: LinkedinOutlined, href: '#linkedin' },
    { name: 'GitHub', icon: GithubOutlined, href: '#github' },
  ]

  return (
    <footer style={{ backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
      <div className="container-custom">
        {/* Main Footer Content */}
        <div style={{ paddingTop: '80px', paddingBottom: '48px' }}>
          <Row gutter={[48, 48]}>
            {/* Brand Section */}
            <Col xs={24} lg={8}>
              <Link to="/" className="inline-block mb-8">
                <img 
                  src="/shiftedtime_logo.png" 
                  alt="ShiftedTime" 
                  className="h-10 w-auto"
                />
              </Link>
              
              <Text style={{ 
                color: '#64748b', 
                fontSize: '16px', 
                lineHeight: '1.6',
                display: 'block',
                marginBottom: '32px',
                maxWidth: '320px'
              }}>
                Die moderne Zeiterfassungslösung für professionelle Teams. 
                Bis 5 Mitarbeiter kostenlos, danach nur 1€ pro Mitarbeiter.
              </Text>
              
              {/* Contact Info */}
              <Space direction="vertical" size="large">
                <div className="flex items-center space-x-4">
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    backgroundColor: '#f1f5f9', 
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <MailOutlined style={{ color: '#2563eb', fontSize: '16px' }} />
                  </div>
                  <div>
                    <Text style={{ color: '#1e293b', fontSize: '16px', fontWeight: 500, display: 'block' }}>
                      info@medconnect.gmbh
                    </Text>
                    <Text style={{ color: '#64748b', fontSize: '14px' }}>
                      Support & Vertrieb
                    </Text>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    backgroundColor: '#f1f5f9', 
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <EnvironmentOutlined style={{ color: '#10b981', fontSize: '16px' }} />
                  </div>
                  <div>
                    <Text style={{ color: '#1e293b', fontSize: '16px', fontWeight: 500, display: 'block' }}>
                      Langenhagen, Deutschland
                    </Text>
                    <Text style={{ color: '#64748b', fontSize: '14px' }}>
                      DSGVO-konform & sicher
                    </Text>
                  </div>
                </div>
              </Space>
            </Col>

            {/* Footer Links */}
            <Col xs={24} lg={16}>
              <Row gutter={[32, 32]}>
                {footerSections.map((section) => (
                  <Col xs={12} sm={8} lg={section.title.includes('Lösungen') ? 6 : 4} key={section.title}>
                    <Title level={5} style={{ 
                      color: '#1e293b', 
                      fontSize: '16px',
                      fontWeight: 600,
                      marginBottom: '24px'
                    }}>
                      {section.title}
                    </Title>
                    <Space direction="vertical" size="middle">
                      {section.links.map((link) => (
                        <div key={link.name}>
                          {link.href.startsWith('#') ? (
                            <a
                              href={link.href}
                              style={{ 
                                color: '#64748b', 
                                fontSize: '15px',
                                textDecoration: 'none',
                                transition: 'color 0.2s ease'
                              }}
                              className="footer-link"
                            >
                              {link.name}
                            </a>
                          ) : (
                            <Link
                              to={link.href}
                              style={{ 
                                color: '#64748b', 
                                fontSize: '15px',
                                textDecoration: 'none',
                                transition: 'color 0.2s ease'
                              }}
                              className="footer-link"
                            >
                              {link.name}
                            </Link>
                          )}
                        </div>
                      ))}
                    </Space>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        {/* Newsletter Section */}
        <div style={{ 
          padding: '48px 0', 
          borderTop: '1px solid #e2e8f0',
          borderBottom: '1px solid #e2e8f0'
        }}>
          <Row align="middle" gutter={[48, 24]}>
            <Col xs={24} md={12}>
              <Title level={4} style={{ 
                color: '#1e293b', 
                fontSize: '20px',
                fontWeight: 600,
                marginBottom: '8px'
              }}>
                Bleiben Sie auf dem Laufenden
              </Title>
              <Text style={{ color: '#64748b', fontSize: '16px' }}>
                Erhalten Sie Updates über neue Features und Zeiterfassungs-Tipps.
              </Text>
            </Col>
            
            <Col xs={24} md={12}>
              <Space.Compact style={{ width: '100%', maxWidth: '400px' }}>
                <Input
                  placeholder="Ihre E-Mail-Adresse"
                  style={{
                    backgroundColor: '#ffffff',
                    borderColor: '#e2e8f0',
                    color: '#1e293b',
                    height: '48px',
                    fontSize: '16px'
                  }}
                />
                <Button 
                  type="primary" 
                  style={{
                    backgroundColor: '#1a202c',
                    borderColor: '#1a202c',
                    height: '48px',
                    fontSize: '16px',
                    fontWeight: 500,
                    paddingLeft: '24px',
                    paddingRight: '24px'
                  }}
                >
                  Abonnieren
                </Button>
              </Space.Compact>
            </Col>
          </Row>
        </div>

        {/* Bottom Footer */}
        <div style={{ padding: '32px 0' }}>
          <Row justify="space-between" align="middle" gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <Text style={{ color: '#64748b', fontSize: '15px' }}>
                © {currentYear} ShiftedTime. Alle Rechte vorbehalten. 
                <span style={{ marginLeft: '16px', color: '#94a3b8' }}>
                  Made with ❤️ in Germany
                </span>
              </Text>
            </Col>
            
            <Col xs={24} md={12} style={{ textAlign: 'right' }}>
              <Space size="large">
                {socialLinks.map((social) => (
                  <Button
                    key={social.name}
                    type="text"
                    icon={<social.icon />}
                    href={social.href}
                    style={{
                      color: '#64748b',
                      width: '40px',
                      height: '40px',
                      borderRadius: '8px',
                      fontSize: '18px',
                      transition: 'all 0.2s ease'
                    }}
                    className="social-button"
                    aria-label={social.name}
                  />
                ))}
              </Space>
            </Col>
          </Row>
        </div>
      </div>
    </footer>
  )
}

export default Footer 